'use client';

import { IconChevronDownFilled } from '@zillow/constellation-icons/react/filled/icon-chevron-down-filled';
import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { expandIconRecipe } from '../../styles/expand-icon.styles';
import { Button } from '../button';
import { DropdownRootContext } from './context/dropdown-root.context';
import type { DropdownButtonPropsInterface } from './types/dropdown-button.types';

export const DropdownButton = forwardRef<HTMLButtonElement, DropdownButtonPropsInterface>(
  (props: DropdownButtonPropsInterface, forwardedRef) => {
    const { children, css: cssProp, ...rest } = props;
    const { dropdown } = useContext(DropdownRootContext);

    const iconStyles = css(expandIconRecipe.raw({ open: dropdown.open }));

    return (
      <Button.Root
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Dropdown.Button"
        tone="brand"
        emphasis="outlined"
        css={cssProp}
        {...rest}
      >
        <Button.Label>{children}</Button.Label>
        <span className={cx('c11n', iconStyles)}>
          <Button.Icon render={<IconChevronDownFilled />} />
        </span>
      </Button.Root>
    );
  },
);

DropdownButton.displayName = 'Dropdown.Button';
